<script>
  import { onMount, onDestroy } from "svelte";
  import { array_move, getCollapseClass } from "../../Common/tools";
  import {External, M} from "../../external";

  export let data,
    isCollapsable = true,
    isCollapsed = true;

  let menu, jMenu, oldPosition;

  function onAdd() {
    data.menu.push({ caption: "", link: "" });
    data = Object.assign({}, data, {});
  }

  function onDelete(idx) {
    data.menu.splice(idx, 1);
    data = Object.assign({}, data, {});
  }

  function toggleCollapse() {
    if (isCollapsable) {
      isCollapsed = !isCollapsed;
    }
  }

  onMount(function () {
    jMenu = External.$(menu);
    jMenu.sortable({
      containment: "parent",
      handle: ".move-icon",
      create: function () {
        oldPosition = jMenu.sortable("toArray");
      },
      stop: function (e, ui) {
        const id = ui.item[0].id,
          newPosition = jMenu.sortable("toArray"),
          oldIndex = oldPosition.indexOf(id),
          newIndex = newPosition.indexOf(id);

        if (newIndex === -1 || oldIndex === -1) {
          oldPosition = newPosition;
          return;
        }

        data.menu = array_move(data.menu, oldIndex, newIndex);
        oldPosition = newPosition;
      }
    });
  });

  onDestroy(function () {
    jMenu.sortable("destroy");
  });
</script>

<div class="col20 f-left t-center mt-15 email-styling-wrapper" on:click={toggleCollapse}>
  <h4 class="t-left {getCollapseClass(isCollapsable, isCollapsed)}">{M.SOCIAL_NETWORKS}</h4>
</div>
{#if !isCollapsed}
  <div class="form-admin-style-2 mb-10 mt-10">
    <a class="middle-button with-icon blue mb-10" on:click={onAdd}>{M.ADD_MENU_ITEM}</a>
    <div class="menu" bind:this={menu}>
      {#each data.menu as item, i (item)}
        <div class="field col20 f-left" id={item.type}>
          <span class="move-icon flex-none button-tooltip" data-tooltip="simpleMove"></span>
          <select class="label-field modify" bind:value={item.type} style="max-width: 145px; height: 42px;">
            <option value="fb">Facebook</option>
            <option value="tw">X</option>
            <option value="in">Linkedin</option>
            <option value="inst">Instagram</option>
            <option value="pi">Pinterest</option>
						<option value="yt">YouTube</option>
						<option value="tk">TikTok</option>
            <option value="link">Link</option>
          </select>
          <input
            type="text"
            name="menuLinkItem"
            tabindex="0"
            class="label-field modify"
            bind:value={item.link}
            placeholder="{M.TITLE}"
            style="max-width: 105px; height: 42px; margin-left: 2px" />
          <div class="buttons-wrapper flex-none">
            <a on:click|preventDefault={() => onDelete(i)} data-tooltip="simpleDelete" class="delete delete-icon light-gray-icon modify button-tooltip mr-10 circle-effect"
              ><i class="material-icons">delete</i></a>
          </div>
        </div>
      {/each}
    </div>
  </div>
  <div class="popup-input-wrapper input-slider-wrapper mt-5">
    <h5 class="inline">{M.THEME}</h5>
    <select class="label-field modify" bind:value={data.menuTheme}>
      <option value="light">{M.LIGHT}</option>
      <option value="dark">{M.DARK}</option>
    </select>
  </div>
{/if}
